var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navigation-links-nav",class:_vm.rootClassName},[_c('a',{staticClass:"navigation-links-text",attrs:{"href":"https://reviews.mecaca.my/#/","target":"_blank","rel":"noreferrer noopener"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }